import React from 'react';
import { MessageSquare, Check } from 'lucide-react';

const WhatsAppConnectionModal = ({
  mobile,
  whatsAppNumber,
  setWhatsAppNumber,
  connectWhatsApp,
  skipWhatsApp
}) => {
  return (
    <div className="fixed inset-0 bg-gray-50 flex items-center justify-center p-3 overflow-y-auto" style={{ zIndex: 220 }}>
      <div className="bg-white w-full max-w-md rounded p-5 shadow-2xl my-auto">

        {/* Header */}
        <div className="text-center mb-4">
          <div className="w-14 h-14 bg-[#e8f7f3] rounded-full flex items-center justify-center mx-auto mb-2">
            <MessageSquare size={28} className="text-[#03a685]" />
          </div>
          <h2 className="text-lg font-bold text-[#282c3f] mb-1">Connect WhatsApp</h2>
          <p className="text-sm text-[#94969f]">
            Get instant order updates and exclusive offers on WhatsApp
          </p>
        </div>

        {/* Benefits */}
        <div className="bg-[#e8f7f3] border border-[#b7e5d8] rounded p-3 mb-4">
          <h3 className="font-semibold text-[#282c3f] mb-2 flex items-center gap-1.5 text-sm">
            <Check size={16} className="text-[#03a685]" />
            Benefits of WhatsApp Updates
          </h3>
          <ul className="space-y-1 text-xs text-[#535766]">
            {[
              'Real-time order and delivery notifications',
              'Exclusive deals and flash sales alerts',
              'Quick customer support via chat',
              'Subscription reminders and updates',
              'Easy reordering with one tap',
            ].map(item => (
              <li key={item} className="flex items-start gap-1.5">
                <span className="text-[#03a685] mt-0.5 flex-shrink-0">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Input */}
        <div className="mb-3">
          <label className="block text-xs font-semibold text-[#535766] mb-1.5">
            Enter WhatsApp Number
          </label>
          <div className="flex items-center border border-[#eaeaec] rounded px-3 py-2.5 focus-within:border-green-500 transition-all">
            <span className="text-[#535766] font-medium mr-2 text-sm">+91</span>
            <input
              type="tel"
              inputMode="numeric"
              maxLength="10"
              value={whatsAppNumber}
              onChange={e => setWhatsAppNumber(e.target.value.replace(/\D/g, ''))}
              placeholder="Enter 10-digit number"
              className="flex-1 outline-none text-[#282c3f] text-base"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="space-y-2">
          <button
            onClick={connectWhatsApp}
            className="w-full bg-[#03a685] text-white py-3 rounded font-semibold flex items-center justify-center gap-2 hover:bg-green-700 transition-all text-sm"
          >
            <MessageSquare size={16} />
            Connect WhatsApp
          </button>
          <button
            onClick={skipWhatsApp}
            className="w-full bg-gray-100 text-[#535766] py-2.5 rounded font-semibold hover:bg-gray-200 transition-all text-sm"
          >
            Skip for Now
          </button>
        </div>

        <p className="text-xs text-[#94969f] text-center mt-2.5">
          You can enable this later from Settings
        </p>
      </div>
    </div>
  );
};

export default WhatsAppConnectionModal;
